<template>
  <div id="insightsDashboard" class="divContainer">
    <div class="divContentInsights margin-subpages">
      <div class="top-contariner flex">
        <div class="engagement">
          <div class="fs-15 fw-700 flex-center">
            {{ $t("insights.Engagement_and_Impact") }}
            <el-tooltip class="header-table-tooltip" placement="top">
              <div slot="content" class="p-5">
                <div style="max-width: 250px">
                  {{ $t("insights.Highlighting_key_engagement_metrics") }}
                </div>
              </div>
              <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                alt="icons_ic_help_outline-16px" />
            </el-tooltip>
            <div class="flex-center"></div>
          </div>
          <div class="card-contariner">
            <div class="flex">
              <div class="engagement-left">
                <div v-if="engagementImpactLoadingStatus">
                  <div class="" style="height: 73px"></div>
                  <div class="fs-10 mt-3 text-skeleton" style="width: 90%">
                    &nbsp;
                  </div>
                  <div class="mt-6 fs-10 text-skeleton" style="width: 40%; background: #6c30cc10">
                    &nbsp;
                  </div>
                </div>
                <div v-else>
                  <div class="grid-dot-10">
                    <div v-for="(value, index) in engagementpeople.arr" :key="index + '_dots_50'"
                      :class="`dots-50 dot-${value}`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="fs-12 mt-3">
                    <span class="fw-900 fc-1AC362">{{ engagementpeople.highImpact }}
                      {{ $t("insights.high_impact") }}
                    </span>
                    <span>{{ $t("insights.contributors") }}</span>
                  </div>
                  <span class="flex-center router-link mt-4" @click="routerLink('insightsWithTab', 'people')">
                    <span>{{ $t("insights.People") }}</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </div>
              <div class="engagement-right">
                <div v-if="engagementImpactLoadingStatus" style="width: 127px">
                  <div class="" style="height: 73px"></div>
                  <div class="fs-10 mt-3 text-skeleton" style="width: 90%">
                    &nbsp;
                  </div>
                  <div class="mt-6 fs-10 text-skeleton" style="width: 40%; background: #6c30cc10">
                    &nbsp;
                  </div>
                </div>
                <div v-else>
                  <div class="grid-dot-7">
                    <div v-for="(value, index) in managerChartData" :key="index + '_dots_28'"
                      :class="`dots-28 dot-${value}`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="fs-12" style="min-width: 136px;">
                    <span class="fw-900" :style="activeIsGreater ? 'color: #1AC362' : 'color: #f47f36'">
                      {{
                        activeIsGreater
                        ? parseInt(this.activeOverview.active)
                        : parseInt(this.activeOverview.passive) + parseInt(this.activeOverview.inactive)
                      }}
                      {{ $t("insights.managers") }}
                    </span>
                    <span>{{ activeIsGreater ? $t("insights.active") : $t("insights.non_active") }}</span>
                  </div>
                  <span class="flex-center router-link mt-4" @click="routerLink('insightsWithTab', 'managers')">
                    <span>{{ $t("insights.Managers") }}</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="x-line my-12"></div>
            <div v-if="engagementImpactLoadingStatus">
              <div class="flex-center">
                <div class="fs-13 fw-700 mr-auto">
                  {{ $t("insights.eNPS") }}
                </div>
                <div class="mt-6 fs-10 text-skeleton" style="width: 30%; background: #6c30cc10">
                  &nbsp;
                </div>
              </div>
              <div class="flex-center mt-12">
                <div class="benchmark mt-12">&nbsp;</div>
                <div class="mx-auto" style="width: 74px">
                  <div class="flex-center text-skeleton" style="width: 80%">
                    &nbsp;
                  </div>
                  <div class="fs-11 mt-6 text-skeleton opa-06" style="width: 100%">
                    &nbsp;
                  </div>
                </div>
                <div class="mx-auto" style="width: 62px">
                  <div class="flex-center text-skeleton" style="width: 80%">
                    &nbsp;
                  </div>
                  <div class="fs-11 mt-6 text-skeleton opa-06" style="width: 100%">
                    &nbsp;
                  </div>
                </div>
                <div class="mx-auto" style="width: 73px">
                  <div class="flex-center text-skeleton" style="width: 80%">
                    &nbsp;
                  </div>
                  <div class="fs-11 mt-6 text-skeleton opa-06" style="width: 100%">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="flex-center">
                <div class="fs-13 fw-700 mr-auto">
                  {{ this.benchmarkBreak }}
                </div>
                <span class="flex-center router-link" @click="routerLink('insightsWithTab', 'report')">
                  <span>{{ $t("insights.Report_Card") }}</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>

              <div v-if="enps.type == 'eNPS' || enps.type == 'NPS'" class="flex-center mt-12">
                <div :class="`benchmark ${enps.total < benchmarkScoreRed()
                  ? 'red'
                  : enps.total < benchmarkScore()
                    ? 'yellow'
                    : 'green'
                  }`">
                  <el-tooltip 
                    placement="top" 
                    effect="light"
                    :visible-arrow="true"
                    popper-class="score-distribution-tooltip">
                    <div slot="content" style="padding: 10px 40px 10px 20px; min-width: 340px;">
                      <div class="tooltip-title">
                        {{ $t("insights.Score_Distribution") }}
                        <span class="opa-04" style="float: right; margin-right: -20px;">
                          {{ getTotalResponses() }} responses
                        </span>
                      </div>
                      <div class="horizontal-histogram">
                        <div class="score-labels">
                          <div v-for="score in getScoreRange()" :key="score" class="score-label-item">
                            {{ formatScoreLabel(score) }}
                          </div>
                        </div>
                        <div class="histogram-bars">
                          <div v-for="score in getScoreRange()" :key="score" class="histogram-bar" 
                               :style="{
                                 height: getScoreWidth(score),
                                 backgroundColor: getScoreColor(score)
                               }">
                          </div>
                        </div>
                        <div class="score-counts">
                          <div v-for="score in getScoreRange()" :key="score" class="score-count-item">
                            ({{getScoreCount(score)}})
                          </div>
                        </div>
                      </div>
                    </div>
                    <span>{{ enps.total > 0 ? "+" + enps.total : enps.total }}</span>
                  </el-tooltip>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.promotors : 0 }}%
                    <img class="ml-6" :src="$utils('icons', 'Promoters_16')" alt="icons_Promoters_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{ $t("insights.Promoters") }} ({{
                      enps.promotors ? enps.promotors : 0
                    }})
                  </div>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.passives : 0 }}%
                    <img class="ml-6" :src="$utils('icons', 'Passives_16')" alt="icons_Passives_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{ $t("insights.Passives") }} ({{
                      enps.passives ? enps.passives : 0
                    }})
                  </div>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.detractors : 0 }}%
                    <img class="ml-6" :src="$utils('icons', 'Distractors_16')" alt="icons_Distractors_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{ $t("insights.Detractors") }} ({{
                      enps.detractors ? enps.detractors : 0
                    }})
                  </div>
                </div>
              </div>
              <div v-else class="flex-center mt-12">
                <div :class="`benchmark ${enps.total < benchmarkScoreRed()
                    ? 'red'
                    : enps.total < benchmarkScore()
                      ? 'yellow'
                      : 'green'
                  }`">
                  <span v-if="checkedInxed">{{
                    enps.total > 0 ? enps.total : enps.total
                  }}</span>
                  <span v-else>{{
                    enps.total > 0 ? "+" + enps.total : enps.total
                  }}</span>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.excellent : 0 }}%
                    <img class="ml-6" :src="$utils('icons', imagesBenchmark('Excellent'))" alt="icons_Promoters_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{ $t("insights.Excellent") }} ({{
                      enps.excellent ? enps.excellent : 0
                    }})
                  </div>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.fair : 0 }}%
                    <img class="ml-6" :src="$utils('icons', imagesBenchmark('Fair'))" alt="icons_Passives_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{ $t("insights.Fair") }} ({{ enps.fair ? enps.fair : 0 }})
                  </div>
                </div>
                <div class="mx-auto">
                  <div class="flex-center fs-14 fw-700">
                    {{ enps.percent ? enps.percent.critical : 0 }}%
                    <img class="ml-6" :src="$utils('icons', imagesBenchmark('Critical'))" alt="icons_Distractors_16" />
                  </div>
                  <div class="fs-11 fw-700 opa-06 mt-4">
                    {{
                      benchmarkBreak == "WHO-5 Wellbeing Index"
                      ? $t("insights.Poor")
                      : $t("insights.Critical")
                    }}
                    ({{ enps.critical ? enps.critical : 0 }})
                  </div>
                </div>
              </div>

              <div class="flex-center fs-12 mt-16">
                <div v-if="enps.total == benchmarkScore()">
                  <span class="fc-000000 fw-400">
                    {{ $t("insights.point_same_benchmark") }} (+{{
                      benchmarkScore()
                    }})</span>
                </div>
                <div v-else>
                  <span class="fw-900 fc-1AC362" v-if="enps.total > benchmarkScore()">{{ enps.total - benchmarkScore() }}
                    {{ $t("insights.points") }}

                    <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span
                        v-if="!checkedInxed">+</span>{{ benchmarkScore() }})</span>
                  </span>
                  <span v-else class="fw-900 fc-F44336">{{
                    isNaN(enps.total)
                    ? 0
                    : (enps.total - benchmarkScore()) * -1
                  }}
                    {{ $t("insights.points") }}

                    <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span
                        v-if="!checkedInxed">+</span>{{ benchmarkScore() }})</span>
                  </span>
                </div>
                <div class="ml-auto">
                  <div class="point-bar">
                    <div class="value" :style="`width: ${benchmarkBar(enps.total)}px; ${enps.total < 0
                      ? ' background-color: #F44336;'
                      : enps.total < benchmarkScore()
                        ? ' background-color: #FBC02D;'
                        : ''
                      }`"></div>
                    <div class="value benchmark" :style="`width: ${benchmarkBar(benchmarkScore())}px;`"></div>
                  </div>
                  <div v-if="checkedInxed" class="flex-center opa-04 fs-10 fw-700 mt-2">
                    <div>0</div>
                    <div class="ml-auto">100</div>
                  </div>
                  <div v-else class="flex-center opa-04 fs-10 fw-700 mt-2">
                    <div>-100</div>
                    <div class="ml-auto">+100</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="weekly-status">
          <div class="fs-15 fw-700">{{ dateshow }}</div>
          <div class="card-contariner">
            <div class="flex">
              <div>
                <div class="fs-12 fw-700" style="width: 96px">
                  {{ $t("insights.Happiness_Rate") }}
                </div>
                <div v-if="weeklyLoadingStatus" class="flex-center mt-6">
                  <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                    &nbsp;
                  </div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="flex-center mt-6">
                  <img :src="$utils('icons', 'Happiness_Rate_24')" alt="icons_Happiness_Rate_24" />
                  <div class="flex-center">
                    <div class="fs-16 fw-700 ml-6">
                      {{ `${happiness.happy}%` }}
                    </div>
                    <div v-if="happiness.calculatehappy != 0" :class="`label-change ${0 > happiness.calculatehappy ? 'fc-F44336' : 'fc-1AC362'
                      }`">
                      {{
                        happiness.calculatehappy > 0
                        ? `+${happiness.calculatehappy}`
                        : `${happiness.calculatehappy}`
                      }}
                      pts
                    </div>
                    <div v-else :class="`label-change fc-6A6A6A`">
                      {{ `+${happiness.calculatehappy}` }} pts
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-12">
                <div class="fs-12 fw-700">{{ $t("insights.Risk_Rate") }}</div>
                <div v-if="weeklyLoadingStatus" class="flex-center mt-6">
                  <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                    &nbsp;
                  </div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="flex-center mt-6">
                  <img :src="$utils('icons', 'Risk_Rate_v3_24')" alt="icons_Risk_Rate_v3_24" />
                  <div class="fs-16 fw-700 ml-6">
                    {{ `${happiness.worse}%` }}
                  </div>
                  <div v-if="happiness.calculaterisk != 0" :class="`label-change ${happiness.calculaterisk * 1 > 0
                    ? 'fc-F44336'
                    : 'fc-1AC362'
                    }`">
                    {{
                      happiness.calculaterisk > 0
                      ? `+${happiness.calculaterisk}`
                      : `${happiness.calculaterisk}`
                    }}
                    pts
                  </div>
                  <div v-else :class="`label-change fc-1AC362`">
                    {{ `+${happiness.calculaterisk}` }} pts
                  </div>
                </div>
              </div>
            </div>
            <div v-if="weeklyLoadingStatus" class="text-skeleton fs-12 mt-12" style="width: 95px; background: #6c30cc10">
              &nbsp;
            </div>
            <span v-else class="flex-center router-link mt-12" @click="routerLink('insightsWithTab', 'teams')">
              <span>{{ $t("insights.View_by_team") }}</span>
              <i class="el-icon-arrow-right"></i>
            </span>
            <div class="x-line my-12"></div>
            <div class="mt-24">
              <div class="fs-12 fw-700">
                {{ $t("insights.Open_ended_Feedback") }}
              </div>
              <div class="fs-12">
                <div v-if="weeklyLoadingStatus" class="flex-center mt-6">
                  <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                    &nbsp;
                  </div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="flex-center my-6">
                  <img width="32" :src="$utils('icons', 'Open-ended_Feedback_24@2x')"
                    alt="icons_Open-ended_Feedback_24@2x" />
                  <div class="fs-16 fw-700 ml-6">
                    {{ `${feedback.feedback}%` }}
                  </div>
                  &nbsp;
                  <div v-if="feedback.calculate != 0" :class="`label-change ${feedback.calculate > 0 ? 'fc-1AC362' : 'fc-F44336'
                    }`">
                    {{
                      feedback.calculate > 0
                      ? `+${feedback.calculate}`
                      : `${feedback.calculate}`
                    }}
                    pts
                  </div>
                  <div v-else :class="`label-change fc-6A6A6A`">
                    {{ `+${feedback.calculate}` }} pts
                  </div>
                </div>
                <div v-if="weeklyLoadingStatus" class="text-skeleton mt-6" style="width: 140px">
                  &nbsp;
                </div>
                <div v-else>
                  <div v-if="feedback.feedback - 40 >= 0">
                    <span class="fw-900 fc-1AC362">{{ feedback.feedback - 40 }}% {{ $t("insights.points") }}
                    </span>
                    <span>{{ $t("insights.above_benchmark") }} (40%)</span>
                  </div>
                  <div v-else>
                    <span class="fw-900 fc-F44336">{{
                      isNaN(feedback.feedback)
                      ? "-"
                      : (feedback.feedback - 40) * -1
                    }}% {{ $t("insights.points") }}
                    </span>
                    <span>{{ $t("insights.below_benchmark") }} (40%)</span>
                  </div>
                </div>
              </div>
            </div>
            <span v-if="!weeklyLoadingStatus" class="flex-center router-link mt-12" @click="
              routerLink('questions', 'standard', questionOpenEnd.question_id)
              ">
              <span class="relative">
                <div class="ellipsis-3">{{ questionOpenEnd.question_en }}</div>
              </span>
              <i class="el-icon-arrow-right ml-auto"></i>
            </span>
          </div>
        </div>

        <div class="activity">
          <div class="fs-15 fw-700">{{ $t("insights.Activity") }}</div>
          <div class="card-contariner">
            <div class="flex-center">
              <div class="fs-12 fw-700 mr-auto">
                {{ $t("insights.Adoption") }}
              </div>
              <div v-if="activityLoadingStatus" class="text-skeleton fs-12" style="width: 60px; background: #6c30cc10">
                &nbsp;
              </div>
              <span v-else class="flex-center router-link" @click="routerLink('members', 'members')">
                <span>{{ $t("insights.Members") }}</span>
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="mt-6">
              <div v-if="activityLoadingStatus" class="bar-contariner flex-center opa-06">
                <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                  :class="`bar ${value}`"></div>
                <div class="text-skeleton ml-6" style="width: 40px">&nbsp;</div>
              </div>
              <div v-else class="bar-contariner flex-center">
                <div v-for="(value, index) in arrayToPercentage(adoption)" :key="index + '_bar_adoption'"
                  :class="`bar ${value}`"></div>
                <div class="fs-16 fw-700 ml-6">{{ adoption }}%</div>
              </div>
            </div>
            <div v-if="activityLoadingStatus" class="text-skeleton mt-6 fs-12 opa-08" style="width: 180px">
              &nbsp;
            </div>
            <div v-else class="mt-6 fs-12">
              <div v-if="adoption - 90 >= 0">
                <span class="fw-900 fc-1AC362">{{ adoption - 90 ? (adoption - 90).toFixed() : 0 }}%
                  {{ $t("insights.points") }}
                </span>
                <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (90%)</span>
              </div>
              <div v-else>
                <span class="fw-900 fc-F44336">{{
                  (adoption - 90) * -1 ? ((adoption - 90) * -1).toFixed() : 0
                }}% {{ $t("insights.points") }}
                </span>
                <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (90%)</span>
              </div>
            </div>

            <div class="x-line my-14"></div>

            <div class="flex-center mt-24">
              <div class="fs-12 fw-700 mr-auto">
                {{ $t("insights.Monthly_Active_Users") }}
              </div>
            </div>
            <div class="mt-6">
              <div v-if="activityLoadingStatus" class="bar-contariner flex-center opa-06">
                <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                  :class="`bar ${value}`"></div>
                <div class="text-skeleton ml-6" style="width: 40px">&nbsp;</div>
              </div>
              <div v-else class="bar-contariner flex-center">
                <div v-for="(value, index) in arrayToPercentage(
                  monthlyActiveUser.bar
                )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                <div class="fs-16 fw-700 ml-6">
                  {{ monthlyActiveUser.activeCurrent }}
                </div>
                <div v-if="monthlyActiveUser.percent_change != 0" :class="`label-change ${0 > monthlyActiveUser.percent_change
                  ? 'fc-F44336'
                  : 'fc-1AC362'
                  }`">
                  {{
                    monthlyActiveUser.percent_change
                    ? monthlyActiveUser.percent_change > 0
                      ? `+${monthlyActiveUser.percent_change}`
                      : monthlyActiveUser.percent_change
                    : 0
                  }}%
                </div>

                <div v-else :class="`label-change fc-6A6A6A`">
                  {{ `+${monthlyActiveUser.percent_change}` }}%
                </div>
              </div>
            </div>
            <div class="flex-center mt-16">
              <div class="fs-12 fw-700 mr-auto">
                {{ $t("insights.Weekly_Active_Users") }}
              </div>
            </div>
            <div class="mt-6">
              <div v-if="activityLoadingStatus" class="bar-contariner flex-center opa-04">
                <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                  :class="`bar ${value}`"></div>
                <div class="text-skeleton ml-6" style="width: 30px">&nbsp;</div>
              </div>
              <div v-else class="bar-contariner flex-center">
                <div v-for="(value, index) in arrayToPercentage(
                  weeklyActiveUser.bar
                )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                <div class="fs-16 fw-700 ml-6">
                  {{ weeklyActiveUser.activeCurrent }}
                </div>
                <div v-if="weeklyActiveUser.percent_change != 0" :class="`label-change ${0 > weeklyActiveUser.percent_change
                  ? 'fc-F44336'
                  : 'fc-1AC362'
                  }`">
                  {{
                    weeklyActiveUser.percent_change
                    ? weeklyActiveUser.percent_change > 0
                      ? `+${weeklyActiveUser.percent_change}`
                      : weeklyActiveUser.percent_change
                    : 0
                  }}%
                </div>
                <div v-else :class="`label-change fc-6A6A6A`">
                  {{ `+${weeklyActiveUser.percent_change}` }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-2-tenure mt-24">
        <div style="justify-content: flex-start">
          <div class="flex">
            <div>
              <span class="fs-15 fw-700">{{
                $t("insights.By_Job_Tenure")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("insights.A_breakdown_of_your") }}
              </div>
              <div style="padding-left: 8px; display: flex; align-items: center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div class="flex-mid barchart-style relative">
            <div v-if="databarchartLoading" class="ml-auto absolute-mid">
              <loading-even></loading-even>
            </div>
            <div v-else-if="!databarchartLoading && !Object.keys(databarchart).length
              " class="opa-06 fs-13">
              Your tenure insights will appear after your first day with Happily. This helps us show you meaningful team patterns.
            </div>
            <div class="pt-20" style="height: 166px; width: 100%">
              <canvas height="166px" ref="barchart"></canvas>
            </div>
          </div>
        </div>
        <div class="past-12-hours ml-16">
          <div class="fs-15 fw-700">
            {{ $t("insights.Real_time_Activity") }}
          </div>
          <div class="card">
            <div class="fc-FFFFFF fw-700 fs-10 flex-center">
              <div class="mr-22">{{ $t("insights.PAST_12_HOURS") }}</div>
              <div>{{ $t("insights.BY_HOUR") }}</div>
            </div>
            <div class="flex">
              <div class="" style="font-size: 29px; width: 90px">
                <div class="mt-24">{{ maximumUsers }}</div>
              </div>
              <div style="height: 70px; width: 110px">
                <canvas ref="pastLinechart"></canvas>
              </div>
            </div>
            <div class="fs-10 fw-700 flex">
              <div>{{ $t("insights.TOP_ACTIVITIES") }}</div>
              <div class="ml-auto">{{ $t("insights.TIMES") }}</div>
            </div>
            <div class="line"></div>
            <div class="flex fs-11 mt-5" v-for="(item, index) in past12Hour" :key="index + '_list_' + item.label">
              <div class="fc-35D077 mr-4">+</div>
              <div>{{ item.label }}</div>
              <div class="ml-auto">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-32">
        <div style="justify-content: flex-start">
          <div class="flex">
            <div>
              <span class="fs-15 fw-700">{{
                $t("insights.Engagement_Trend")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("insights.Engagement_Trend_Desc") }}
              </div>
              <div style="padding-left: 8px; display: flex; align-items: center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-3-engagement mt-12">
          <div style="justify-content: flex-start">
            <div class="flex">
              <div>
                <div class="fs-12 chart-legend">
                  <div class="label">Overall</div>
                  <div class="symbol blue"></div>
                  <div class="score">{{ (databarchartEngagementScore['company']) ? databarchartEngagementScore['company'][databarchartEngagementScore['company'].length - 1] : '' }}</div>
                  <div :class="`tag ${detectColorTotal('company')}`">{{detectTextTotal('company')}}</div>
                </div>
              </div>
            </div>
            <div class="flex-mid barchart-engagement-style relative">
              <div v-if="EngagementScoreLoading" class="ml-auto absolute-mid">
                <loading-even></loading-even>
              </div>
              <div v-else-if="!EngagementScoreLoading && databarchartEngagementScore['company'] && !Object.keys(databarchartEngagementScore['company']).length
                " class="opa-06 ml-auto absolute-mid">
                Pending Data
              </div>
              <div class="" style="height: 80px; width: 100%">
                <canvas height="166px" ref="chartEngagementScoreCompany"></canvas>
              </div>
            </div>
          </div>

          <div style="justify-content: flex-start">
            <div class="flex">
              <div>
                <div class="fs-12 chart-legend">
                  <div class="label">Managers</div>
                  <div class="symbol orange"></div>
                  <div class="score">{{ (databarchartEngagementScore['manager']) ? databarchartEngagementScore['manager'][databarchartEngagementScore['manager'].length - 1] : '' }}</div>
                  <div :class="`tag ${detectColorTotal('manager')}`">{{detectTextTotal('manager')}}</div>
                </div>
              </div>
            </div>
            <div class="flex-mid barchart-engagement-style relative">
              <div v-if="EngagementScoreLoading" class="ml-auto absolute-mid">
                <loading-even></loading-even>
              </div>
              <div v-else-if="!EngagementScoreLoading && databarchartEngagementScore['manager'] && !Object.keys(databarchartEngagementScore['manager']).length
                " class="opa-06 ml-auto absolute-mid">
                Pending Data
              </div>
              <div class="" style="height: 80px; width: 100%">
                <canvas height="166px" ref="chartEngagementScoreManager"></canvas>
              </div>
            </div>
          </div>

          <div style="justify-content: flex-start">
            <div class="flex">
              <div>
                <div class="fs-12 chart-legend">
                  <div class="label">Leadership</div>
                  <div class="symbol pink"></div>
                  <div class="score">{{ (databarchartEngagementScore['leader']) ? databarchartEngagementScore['leader'][databarchartEngagementScore['leader'].length - 1]: '' }}</div>
                  <div :class="`tag ${detectColorTotal('leader')}`">{{detectTextTotal('leader')}}</div>
                </div>
              </div>
            </div>
            <div class="flex-mid barchart-engagement-style relative">
              <div v-if="EngagementScoreLoading" class="ml-auto absolute-mid">
                <loading-even></loading-even>
              </div>
              <div v-else-if="!EngagementScoreLoading && databarchartEngagementScore['leader'] && !Object.keys(databarchartEngagementScore['leader']).length
                " class="opa-06 ml-auto absolute-mid">
                Pending Data
              </div>
              <div class="" style="height: 80px; width: 100%">
                <canvas height="166px" ref="chartEngagementScoreLeader"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        <span class="fs-15 fw-700">{{
          $t("insights.Engagement_Score")
        }}</span>
      </div>
      <div class="grid-3-engagement mt-32">
      </div> -->

      <div style="justify-content: flex-end" class="mt-24">
        <div class="flex center" style="padding-bottom: 12px">
          <div>
            <span class="fs-15 fw-700">{{
              $t("insights.Key_Teams_and_Cohorts")
            }}</span>
          </div>
          <el-tooltip effect="dark" placement="top">
            <div class="tooltipHelpStyle" slot="content">
              {{ $t("insights.Highlighting_key_groups") }}
            </div>
            <div style="padding-left: 8px; display: flex; align-items: center">
              <img :src="getImgUrl('help_outline-16px')" />
            </div>
          </el-tooltip>
        </div>
        <div class="grid-5-20" v-if="datakeyGroupLoading">
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
          <div class="KeyGroupBox text-skeleton"></div>
        </div>
        <div class="grid-5-20" v-else>
          <div v-for="item in datakeygroup" :key="item.key">
            <el-tooltip effect="dark" placement="top" :disabled="item.keygroup.length < 16">
              <div class="tooltipKeyGroupStyle" 
              :class="[ blurMode ?  'blurelement': '' ]"
              slot="content">
                {{ item.keygroup }}
              </div>
              <div class="KeyGroupBox"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div style="
                    padding-top: 16px;
                    padding-left: 14px;
                    position: absolute;
                  ">
                  <img v-if="item.emotion == 'bad'" :src="getImgUrlDim('ic_sad')" />
                  <img v-else-if="item.emotion == 'low_activity'" :src="getImgUrlDim('ic_low_activity')" />
                  <img v-else-if="item.emotion == 'low_feedback'" :src="getImgUrlDim('ic_low_feedback')" />
                  <img v-else :src="getImgUrlDim('ic_happy')" />
                </div>
                <div class="pt-4 pr-6" style="padding-left: 39px">
                  <span class="txtHeaderKey">{{
                    truncateTextKeyGroup(item.keygroup)
                  }}</span>
                </div>
                <div style="padding-left: 39px; margin-top: -5px">
                  <span class="txtDetailKey">{{ item.desc_text }}</span>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div class="grid-2-second mt-32">
        <div>
          <div class="flex-center">
            <div class="fs-18 fw-700">{{ $t("insights.TONE_ANALYZER") }}</div>
            <!-- <span class="icon-beta">{{ $t("insights.BETA") }}</span> -->
          </div>
          <div v-if="!toneLoadingData">
            <div class="tone-body flex" v-for="(data, index) of toneData" :key="index + data.emoji">
              <div class="arrow flex-mid">
                <div class="flex-mid mt-8" v-if="data.rankingNow !== 0 && data.rankYesterdayDay !== 0">
                  <img v-if="data.rankingNow < data.rankYesterdayDay" src="../../assets/images/insights/ic_rank_up.png"
                    alt="" />
                  <img v-else-if="data.rankingNow > data.rankYesterdayDay"
                    src="../../assets/images/insights/ic_rank_down.png" class="mb-2" alt="" />
                  <img v-else src="../../assets/images/insights/ic_rank_same.png" alt="" />
                </div>
                <div class="flex-mid mt-8" v-else-if="data.rankYesterdayDay === 0">
                  <img src="../../assets/images/insights/ic_rank_up.png" alt="" />
                </div>
                <div class="flex-mid mt-6" v-else-if="data.rankingNow === 0">
                  <img src="../../assets/images/insights/ic_rank_down.png" alt="" />
                </div>
              </div>
              <div class="number fs-14 fw-500 opa-06">
                {{ data.rankingNow }}
              </div>
              <el-tooltip placement="top">
                <div slot="content" class="tooltip-emoji-detail">
                  {{ data.details }}
                </div>
                <div class="emoji fs-14 fw-500 opa-09 ellipsis">
                  {{ data.emoji }} {{ data.emojiText }}
                </div>
              </el-tooltip>
              <div class="percentage-bar ellipsis">
                <el-progress :percentage="data.percentage" :show-text="false" color="#6c30cc"></el-progress>
              </div>
              <div class="percentage-number opa-09 fs-14">
                {{ data.percentage }}%
              </div>
              <div class="percentage-change-number" :class="`${data.percentageChange >= 0 ? 'up' : 'down'}`">
                {{ data.percentageChange >= 0 ? "+" : "" }}
                {{ data.percentageChange }}%
              </div>
            </div>
          </div>
          <div v-else>
            <div class="tone-body text-skeleton" style="height: 20px; width: 320px"></div>
            <div class="tone-body text-skeleton" style="height: 20px; width: 320px"></div>
            <div class="tone-body text-skeleton" style="height: 20px; width: 320px"></div>
            <div class="tone-body text-skeleton" style="height: 20px; width: 220px"></div>
          </div>
        </div>
        <div>
          <div class="">
            <div class="flex-1">
              <span class="fs-18 fw-700">{{
                $t("insights.TALKING_POINTS")
              }}</span>
              <el-button type="text" class="txtButton" @click="showList">{{
                $t("insights.show_timeline")
              }}</el-button>
            </div>
          </div>
          <el-dialog :visible.sync="dialogVisible">
            <span slot="title">
              <div class="headerModalStyle flex-center">
                <div class="flex-1">
                  <span class="fs-20 fw-800 fc-2F2F2F">{{
                    $t("insights.TALKING_POINTS")
                  }}</span>
                </div>
                <div>
                  <el-tag style="margin: 0 8px 0 0 !important" class="talking-points mt-2 mb-6 GreenBoxStyle">{{
                    $t("insights.Positive") }}</el-tag>
                  <el-tag style="margin: 0 8px 0 0 !important" class="talking-points mt-2 mb-6 GreyBoxStyle">{{
                    $t("insights.Neutral") }}</el-tag>
                  <el-tag style="margin: 0 8px 0 0 !important" class="talking-points mt-2 mb-6 RedBoxStyle">{{
                    $t("insights.Critical") }}</el-tag>
                </div>
              </div>
            </span>
            <div class="scroll-style thin-scrollbar">
              <div class="center mt-40 pt-40 mb-10 pb-10" v-if="loadingTimeLineTalkingPoints">
                <loading-even></loading-even>
              </div>
              <div class="mx-52 mb-30" v-for="(item, index) in talking_points_monthly" :key="index">
                <div style="display: flex; justify-content: center" class="mb-24 mt-20">
                  <span class="txtMonthlyStyle">{{ setMonthly(index) }}</span>
                </div>
                <div v-if="index < '2024-12'" class="flex" style="flex-wrap: wrap">
                  <div class="talkingPointsBox flex" v-for="_value in item.slice(0, 20)" :key="_value._id">
                    <el-tooltip v-if="_value.short_answer.length > maxLength" effect="dark" placement="top">
                      <div class="tooltipStyle" slot="content">
                        {{ _value.short_answer }}
                      </div>
                      <el-tag :class="`talking-points ${_value.sentiment > 0
                        ? 'GreenBoxStyle'
                        : _value.sentiment < 0
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', _value.short_answer)
    ">{{ truncateText(_value.short_answer) }}</el-tag>
                    </el-tooltip>
                    <div v-else>
                      <el-tag :class="`talking-points ${_value.sentiment > 0
                        ? 'GreenBoxStyle'
                        : _value.sentiment < 0
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', _value.short_answer)
    ">{{ truncateText(_value.short_answer) }}</el-tag>
                    </div>
                  </div>
                </div>
                <div v-else class="flex" style="flex-wrap: wrap">
                  <div class="talkingPointsBox flex" v-for="(_value,i_array) in item.slice(0, 20)" :key="index+'_'+i_array">
                    <el-tooltip effect="light" placement="top" class="custom-tooltip">
                      <div class="tooltipStyle" slot="content">
                        <span class="fs-13 fw-700">{{ _value.point.title }}</span>
                        <div v-if="_value.point && _value.point.specific_examples">
                          <div class="tooltip-items" v-for="(item_specific,index_specific) in _value.point.specific_examples" :key="index+'_'+index_specific">
                            <div class="tooltip-item">
                              <div class="oi-circle"> 
                                <span class="fs-11">{{ index_specific+1 }}</span>
                              </div>
                              <p>
                                {{ item_specific }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-tag :class="`talking-points ${_value.sentiment == 'positive'
                        ? 'GreenBoxStyle'
                        : _value.sentiment == 'negative'
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', _value.point.title)
    ">{{ truncateText(_value.point.title) }}</el-tag>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <span slot="footer" class="dialog-footer" style="margin-right: 10px">
              <el-button @click="dialogVisible = false" class="buttonClose btn-gray-outline">{{ $t("insights.Close")
              }}</el-button>
            </span>
          </el-dialog>
          <div style="margin-top: 8px; max-height: 164px; flex-wrap: wrap" class="thin-scrollbar flex">
            <div class="talkingPointsBox" v-for="(item,index) in talking_points_daily.slice(0, 20)" :key="index">
              <el-tooltip effect="light" placement="top" class="custom-tooltip">
                <div class="tooltipStyle" slot="content">
                  <span class="fs-13 fw-700">{{ item.point.title }}</span>
                  <div v-if="item.point && item.point.specific_examples">
                    <div class="tooltip-items" v-for="(item_specific,index_specific) in item.point.specific_examples" :key="index+'_'+index_specific">
                      <div class="tooltip-item">
                        <div class="oi-circle">
                          <span class="fs-11">{{ index_specific+1 }}</span>
                        </div>
                        <p>
                          {{ item_specific }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <el-tag :class="`talking-points ${item.sentiment == 'positive'
                  ? 'GreenBoxStyle'
                  : item.sentiment == 'negative'
                    ? 'RedBoxStyle'
                    : 'GreyBoxStyle'
                  }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', item.point.title)
    ">{{ truncateText(item.point.title) }}</el-tag>
              </el-tooltip>
              <!-- <el-tooltip v-if="item.point && item.point.title && item.point.title.length > maxLength && index < 8" effect="dark" placement="top">
                <div class="tooltipStyle" slot="content">
                  {{ item.point.title }}
                </div>
                <el-tag :class="`talking-points ${item.sentiment == 'positive'
                  ? 'GreenBoxStyle'
                  : item.sentiment == 'negative'
                    ? 'RedBoxStyle'
                    : 'GreyBoxStyle'
                  }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', item.point.title)
    ">{{ truncateText(item.point.title) }}</el-tag>
              </el-tooltip>
              <div v-else-if="index < 8">
                <el-tag :class="`talking-points ${item.sentiment == 'positive'
                  ? 'GreenBoxStyle'
                  : item.sentiment == 'negative'
                    ? 'RedBoxStyle'
                    : 'GreyBoxStyle'
                  }`" v-bind:style="'margin-bottom: 8px;' +
    $utils('fontStyle', item.point.title)
    ">{{ truncateText(item.point.title) }}</el-tag>
              </div> -->
              <!-- <div class="" v-else-if="index === 8">
                <el-tag
                  v-if="talking_points_daily.length - 8 > 0"
                  class="talking-points GreyBoxStyle cursor-pointer"
                  v-bind:style="'max-width: 375px;'"
                  @click="showList"
                >+{{ talking_points_daily.length - 8 }}</el-tag>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="flex-center mt-40">
        <div class="flex-1">
          <span class="fs-18 fw-700">{{
            $t("insights.ENGAGEMENT_BREAKDOWN_BY_TEAM")
          }}</span>
        </div>
        <div style="padding-right: 12px">
          <span class="fc-000000 fs-14">{{ $t("insights.Sort_by") }}</span>
        </div>
        <div class="showOption">
          <el-menu class="el-menu-demo menuOptionStyle" mode="horizontal" style="width: 220px">
            <el-submenu index="0" style="width: 220px">
              <template slot="title">
                <span class="fc-4A4A4A fs-16 ml-16" style="width: 160px; display: inline-block" id="sortby">{{
                  $t("insights.Lowest_Success_Score") }}</span>
              </template>
              <el-menu-item index="1" class="ml-16 fs-16" @click="sortBy('lowest')" style="width: 220px">{{
                $t("insights.Lowest_Success_Score") }}</el-menu-item>
              <el-menu-item index="2" class="ml-16 fs-16" @click="sortBy('highest')" style="width: 220px">{{
                $t("insights.Highest_Success_Score") }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="divTable">
        <el-table :data="questions" :default-sort="{ prop: 'name', order: 'ascending' }" style="width: 100%"
          empty-text="Loading...">
          <el-table-column :label="$t('insights.Dimension')" width="90" align="center">
            <template slot-scope="scope">
              <div class="flex-center">
                <img v-if="scope.row.dimpic" v-lazy="getImgUrlDim(scope.row.dimpic)"
                  class="image-skeleton image-profile-60" />
                <div v-else class="divCurclePic"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div class="flex-column" style="cursor: pointer" @click="DimensionClicked(scope.row)">
                <span class="fc-4A4A4A fs-16 fw-700">{{ scope.row.name }}</span>
                <span class="txtDetailTable">{{
                  questions_name[scope.row.quest_id]
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('insights.Status_no_teams')" width="190" align="center">
            <template slot-scope="scope">
              <div class="flex-center">
                <div class="divCurcleStatus green">
                  <span class="txtStatus">{{
                    $utils("addCommasInNumber", scope.row.status.green)
                  }}</span>
                </div>
                <div class="divCurcleStatus yellow">
                  <span class="txtStatus">{{
                    $utils("addCommasInNumber", scope.row.status.yellow)
                  }}</span>
                </div>
                <div class="divCurcleStatus red">
                  <span class="txtStatus">{{
                    $utils("addCommasInNumber", scope.row.status.red)
                  }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop :label="$t('insights.Success_Score')" width="120" align="right">
            <template slot-scope="scope">
              <span class="fc-2B2B2B fs-16">{{ scope.row.success }}</span>
              <span v-if="scope.row.compare > 0" class="txtPercent green">+{{ scope.row.compare }}%</span>
              <span v-else-if="scope.row.compare < 0" class="txtPercent red">{{ scope.row.compare }}%</span>
              <span v-else-if="scope.row.compare == 0" class="txtPercent">+0%</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog :visible.sync="dialogDimensionVisible">
        <span slot="title">
          <div class="headerModalStyle flex-center">
            <div class="flex-1">
              <span class="fs-20 fw-800 fc-2F2F2F">{{
                $t("insights.DIMENSION_DETAILS")
              }}</span>
            </div>
          </div>
        </span>
        <div class="scroll-style scrollingStyle2 thin-scrollbar">
          <div class="mt-2 mx-20 mb-32">
            <div class="flex-center-1">
              <img v-if="dimensionData.dimpic" :src="getImgUrlDim(dimensionData.dimpic)"
                class="image-skeleton image-profile-60" />
              <div v-else class="divCurclePic"></div>
              <div class="ml-21 mt-10">
                <div>
                  <span class="fc-000000 fs-18 fw-700">{{
                    dimensionData.name
                  }}</span>
                </div>
                <div class="mt-4">
                  <span class="txtDimensionDesc">{{
                    questions_name[dimensionData.quest_id]
                  }}</span>
                </div>
              </div>
            </div>
            <div class="flex mt-15" style="height: 300px">
              <canvas ref="chartTalkingPoints" class="chartStyle"></canvas>
            </div>
            <div class="flex-1 mt-24 mb-16">
              <span class="fs-18 fc-000000 fw-700">
                {{ $t("insights.TALKING_POINTS") }}
              </span>
            </div>
            <div style="margin-top: 8px; max-height: 164px; flex-wrap: wrap" class="flex">
              <div class="talkingPointsBox" v-for="(item,index) in talking_points_30d.slice(0, 20)" :key="index">
                <el-tooltip effect="light" placement="top" class="custom-tooltip">
                  <div class="tooltipStyle" slot="content">
                    <span class="fs-13 fw-700">{{ item.point.title }}</span>
                    <div v-if="item.point && item.point.specific_examples">
                      <div class="tooltip-items" v-for="(item_specific,index_specific) in item.point.specific_examples" :key="index+'_'+index_specific">
                        <div class="tooltip-item">
                          <div class="oi-circle">
                            <span class="fs-11">{{ index_specific+1 }}</span>
                          </div>
                          <p>
                            {{ item_specific }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-tag :class="`talking-points ${item.sentiment == 'positive'
                    ? 'GreenBoxStyle'
                    : item.sentiment == 'negative'
                      ? 'RedBoxStyle'
                      : 'GreyBoxStyle'
                    }`" v-bind:style="'margin-bottom: 8px;' +
                      $utils('fontStyle', item.point.title)
                      ">{{ truncateText(item.point.title) }}</el-tag>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px">
          <el-button @click="dialogDimensionVisible = false" class="buttonClose btn-gray-outline">{{ $t("insights.Close")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
Chart.defaults.font.family = "Lato";
import ChartDataLabels from "chartjs-plugin-datalabels";
import format from "date-fns/format";
import { Result } from "element-ui";

export default {
  name: "dashboard",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    //this.$store.dispatch("dashboard/closeAdoption", this.user);

    this.$store
      .dispatch("dashboard/getMemberAndTeam", this.user)
      .then((result) => {
        // this.$store.dispatch("insightsManagers/getDataAll");
        this.$store.dispatch("dashboard/getManager", result.users);
        this.$store.dispatch("dashboard/getAdoption", result.users);
        this.$store.dispatch("dashboard/getImpactRating", result.users);
        this.$store.dispatch("dashboard/getEnps", {
          user: this.user,
          teams: result.teams,
        });
      });
    this.$store.dispatch("dashboard/getPast12Hours", this.user);
    this.$store.dispatch("dashboard/getGlobalVariable", this.$global_variable);
    this.$store.dispatch("dashboard/setWeekOfYear");
    this.$store.dispatch("dashboard/getActivityThisWeek", this.user);
    this.$store.dispatch("dashboard/getHappinessThisWeek", this.user);
    this.$store.dispatch("dashboard/getFeedbackThisWeek", this.user);
    this.$store.dispatch("dashboard/getQuestionData", this.user);
    this.$store.dispatch("dashboard/getQuestionsName");
    this.$store.dispatch("dashboard/getTalkPointsDaily", this.user);
    this.$store.dispatch("dashboard/getDataJobTenure", this.user);
    this.$store.dispatch("dashboard/getDataKeyGroup", this.user);
    this.$store.dispatch("dashboard/getDataToneAnalyze", this.user);
    this.$store.dispatch("dashboard/getQuestionOpenEnd", this.user);
    this.$store.dispatch("dashboard/getDataEngagementScore", this.user);

    //this.$store.dispatch("dashboard/getImpactRating");

      this.$store.dispatch("dashboard/getComEncryp", this.user);
  },
  props: {
    tabActive: String,
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    dimension() {
      return this.$store.getters["insights/dimension"];
    },
    activeuser() {
      return this.$store.getters["dashboard/activeuser"];
    },
    happiness() {
      return this.$store.getters["dashboard/happiness"];
    },
    feedback() {
      return this.$store.getters["dashboard/feedback"];
    },
    dateshow() {
      return this.$store.getters["dashboard/dateshow"];
    },
    questions() {
      return this.$store.getters["dashboard/questions"];
    },
    questions_name() {
      return this.$store.getters["dashboard/questions_name"];
    },
    talking_points_daily() {
      return this.$store.getters["dashboard/talking_points_daily"];
    },
    talking_points_monthly() {
      this.talkingPointsTimeLineCallAPI = ++this.talkingPointsTimeLineCallAPI;
      return this.$store.getters["dashboard/talking_points_monthly"];
    },
    talking_points_30d() {
      return this.$store.getters["dashboard/talking_points_30d"];
    },
    datachart() {
      return this.$store.getters["dashboard/datachart"];
    },
    databarchart() {
      return this.$store.getters["dashboard/databarchart"];
    },
    databarchartLoading() {
      return this.$store.getters["dashboard/datachartloadingStatus"];
    },
    databarchartEngagementScore() {
      return this.$store.getters["dashboard/databarchartEngagementScore"];
    },
    EngagementScoreLoading() {
      return this.$store.getters["dashboard/EngagementScoreLoadingStatus"];
    },
    datakeygroup() {
      return this.$store.getters["dashboard/datakeygroup"];
    },
    datakeyGroupLoading() {
      return this.$store.getters["dashboard/datakeygrouploadingStatus"];
    },
    opt_month_name() {
      return this.$store.getters["dashboard/opt_month_name"];
    },
    loadingTimeLineTalkingPoints() {
      if (
        Object.keys(this.talking_points_monthly).length === 0 &&
        this.talkingPointsTimeLineCallAPI < 2
      ) {
        return true;
      } else {
        return false;
      }
    },
    newLabels() {
      return this.$store.getters["dashboard/newLabels"];
    },
    toneData() {
      return this.$store.getters["dashboard/toneAnalyse"];
    },
    toneLoadingData() {
      return this.$store.getters["dashboard/toneloadingStatus"];
    },
    maximumUsers() {
      return this.$store.getters["dashboard/maximumUsers"];
    },
    past12Hour() {
      return this.$store.getters["dashboard/past12Hour"];
    },
    activeRecord() {
      return this.$store.getters["dashboard/activeRecord"];
    },
    questionOpenEnd() {
      return this.$store.getters["dashboard/questionOpenEnd"];
    },
    activeOverview() {
      return this.$store.getters["dashboard/managerData"];
    },
    engagementpeople() {
      return this.$store.getters["dashboard/engagementpeople"];
    },
    enps() {
      return this.$store.getters["dashboard/enps"];
    },
    adoption() {
      return this.$store.getters["dashboard/adoption"];
    },
    monthlyActiveUser() {
      return this.$store.getters["dashboard/monthlyActiveUser"];
    },
    weeklyActiveUser() {
      return this.$store.getters["dashboard/weeklyActiveUser"];
    },
    enpsLoading() {
      return this.$store.getters["dashboard/enpsLoading"];
    },
    impactRatingLoading() {
      return this.$store.getters["dashboard/impactRatingLoading"];
    },
    happinessLoading() {
      return this.$store.getters["dashboard/happinessLoading"];
    },
    feedbackLoading() {
      return this.$store.getters["dashboard/feedbackLoading"];
    },

    activityLoadingStatus() {
      return this.$store.getters["dashboard/activityLoadingStatus"];
    },
    benchmarkBreak() {
      return this.$store.getters["dashboard/benchmarkBreak"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    activeIsGreater() {
      return (
        parseInt(this.activeOverview.active) >
        (parseInt(this.activeOverview.passive) + parseInt(this.activeOverview.inactive))
      );
    },
  },
  beforeDestroy() {
    this.$store.dispatch("dashboard/closePast12Hours", this.user);
    // this.$store.dispatch("dashboard/closeAdoption", this.user);
  },
  data() {
    return {
      dialogVisible: false,
      dialogDimensionVisible: false,
      dimensionData: [
        {
          dimpic: "",
          name: "",
          quest_id: "",
        },
      ],
      talkingg_point_bar_chart: "",
      engagement_score_bar_chart: "",
      dashboard_bar_chart: "",
      real_time_chart: "",
      maxLength: 60,
      //benchmarkBreak: "eNPS",
      chartOptions: {
        // responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "none",
        },
        title: {
          display: false,
        },
        hover: {
          animationDuration: 0,
        },
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                display: false,
                beginAtZero: true,
                stepSize: 20,
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                fontColor: "black",
              },
            },
          ],
        },
        layout: {
          padding: {
            top: 18,
          },
        },
      },
      talkingPointsTimeLineCallAPI: 0,
      managerChartData: [],
      engagementImpactLoadingStatus: true,
      weeklyLoadingStatus: true,
      managerLoading: true,
    };
  },
  watch: {
    datachart() {
      if (this.talkingg_point_bar_chart)
        this.talkingg_point_bar_chart.destroy();
      this.randerChart();
    },
    databarchart() {
      if (this.dashboard_bar_chart) this.dashboard_bar_chart.destroy();
      this.randerBarChart();
    },
    databarchartEngagementScore() {
      if (this.engagement_score_bar_chart)
        this.engagement_score_bar_chart.destroy();
      this.renderChartEngagementScoreCompany();
      this.renderChartEngagementScoreManager();
      this.renderChartEngagementScoreLeader();
    },
    activeOverview() {
      this.managerChart();
    },
    activeRecord() {
      if (this.real_time_chart) this.real_time_chart.destroy();
      this.randerLineChart();
    },
    enpsLoading() {
      this.setEngagementImpactLoading();
    },
    managerLoading() {
      this.setEngagementImpactLoading();
    },
    impactRatingLoading() {
      this.setEngagementImpactLoading();
    },
    happinessLoading() {
      this.setWeeklyLoadingStatus();
    },
    feedbackLoading() {
      this.setWeeklyLoadingStatus();
    },
    tabActive(val) {
      if (this.talkingg_point_bar_chart) {
        this.talkingg_point_bar_chart.destroy();
      }
      if (this.dashboard_bar_chart) {
        this.dashboard_bar_chart.destroy();
      }
      if (this.real_time_chart) {
        this.real_time_chart.destroy();
      }

      if (val == "dashboard") {
        this.randerChart();
        this.randerBarChart();
        this.randerLineChart();
      }
    },
    enps: {
      handler(newVal) {
        console.log('eNPS object:', newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    randerLineChart() {
      var chart = this.$refs.pastLinechart;
      if (chart) {
        const lineChartData = {
          labels: this.activeRecord.time, //["04-05 AM","04-05 AM","04-05 AM","","","","","","","","","04-05 AM"],
          datasets: [
            {
              backgroundColor: "#7E3FC700",
              borderColor: "#35D077",
              pointHoverBackgroundColor: "#35D077",
              pointBackgroundColor: "#35D077",
              pointRadius: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4],
              lineTension: 0,
              data: [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4, 12], // TODO: Add data to data
              data: this.activeRecord.data, // [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4 , 12], // TODO: Add data to data
              pointHitRadius: 6,
              pointHoverRadius: 6,
              borderWidth: 2,
              // data: this.activeRecord.data, // [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4 , 12], // TODO: Add data to data
            },
          ],
        };
        var ctx = chart.getContext("2d");
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins = {
          legend: {
            display: false,
          },
          tooltip: {
            mode: "index",
            position: "nearest",
            displayColors: false,
            callbacks: {
              label: function (tooltipItems) {
                const label = tooltipItems.dataset.label;
                const value = tooltipItems.formattedValue;
                return `Active: ${value}`;
              },
            },
          },
        };
        options.scales.y.display = false;
        options.scales.x.display = false;
        this.real_time_chart = new Chart(ctx, {
          type: "line",
          data: lineChartData,
          options: options,
        });
      }
    },
    randerBarChart() {
      var chart = this.$refs.barchart;
      let chartlabels = [];
      this.databarchart.labels.forEach(function (item, index) {
        chartlabels.push(item.split("yr").join(" yr"));
      });
      if (chart && this.databarchart) {
        const barChartData = {
          labels: chartlabels,
          datasets: [
            {
              label: "Weekly Active",
              backgroundColor: "#7E3FC7",
              borderColor: "#6C30CC",
              borderWidth: 1,
              
              data: this.databarchart.active,
              people_count: this.databarchart.people_count,
              datalabels: {
                display: false,
              },
            },
            {
              label: "Happiness",
              backgroundColor: "#66BB6A",
              borderColor: "#66BB6A",
              borderWidth: 1,
              data: this.databarchart.happy,
              datalabels: {
                display: false,
              },
            },
            {
              label: "Risk",
              backgroundColor: "#F44336",
              borderColor: "#F44336",
              borderWidth: 1,
              data: this.databarchart.worse,
              datalabels: {
                color: "#F44336",
                anchor: "end",
                align: "end",
                clamp: true,
                offset: 0,
              },
            },
            {
              label: "Open Feedback Rate",
              backgroundColor: "#999",
              borderColor: "#999",
              borderWidth: 1,
              data: this.databarchart.feedback,
              datalabels: {
                display: false,
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.datalabels = {
          formatter: function (value, context) {
            return value + "%";
          },
          font: {
            weight: "bold",
            size: 10,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              const value = tooltipItems.formattedValue;
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.people_count[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people} people)`;
              }
              return `${label}: ${value}%`;
            },
          },
        };
        const ctx = chart.getContext("2d");
        this.dashboard_bar_chart = new Chart(ctx, {
          type: "bar",
          plugins: [ChartDataLabels],
          data: barChartData,
          options: options,
        });
      }
    },
    randerChart() {
      var chart = this.$refs.chartTalkingPoints;
      if (chart) {
        var ctx = chart.getContext("2d");
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.responsive = true;
        options.maintainAspectRatio = false;
        // const data = {
        //   datasets: [
        //     {
        //       label: "My First Dataset",
        //       data: [65, 59, 80, 81, 56, 55, 40],
        //       fill: false,
        //       borderColor: "rgb(75, 192, 192)",
        //       tension: 0.1,
        //     },
        //   ],
        // };
        this.talkingg_point_bar_chart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.opt_month_name,
            datasets: [
              {
                label: "SUCCESS SCORE",
                data: this.datachart.success,
                newLabels: this.newLabels,
                backgroundColor: "rgba(226, 215, 244, 1)",
                fill: true,
                borderColor: "rgba(108, 48, 204, 1)",
                borderWidth: 1,
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            scales: {
              y: {
                max: 100,
                min: 0,
                ticks: {
                  stepSize: 50,
                  callback: function (value) {
                    return value + "%";
                  },
                },
              },
              x: {
                ticks: {
                  autoSkip: false,
                },
              },
            },
            plugins: {
              datalabels: {
                formatter: function (value, context) {
                  return value + "%";
                },
                font: {
                  weight: "bold",
                  size: 10,
                },
              },
              tooltip: {
                mode: "index",
                position: "nearest",
                callbacks: {
                  title: function (tooltipItems) {
                    return tooltipItems[0].dataset.newLabels[
                      tooltipItems[0].dataIndex
                    ];
                  },
                  label: function (tooltipItems) {
                    const label = tooltipItems.dataset.label;
                    const value = tooltipItems.formattedValue;
                    return `${label}: ${value}%`;
                  },
                },
              },
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            responsive: true,
          },
        });
      }
    },
    renderChartEngagementScoreCompany() {
      var chart = this.$refs.chartEngagementScoreCompany;
      if (chart) {
        var ctx = chart.getContext("2d");
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

        options.responsive = true;
        options.maintainAspectRatio = false;
        let opt_month_name = this.databarchartEngagementScore['labels']
        let maxScore = this.databarchartEngagementScore['maxScore']
        let yMax = maxScore < 50 ? 50 : (maxScore < 75 ? 75 : 100);
        this.engagement_score_bar_chart = new Chart(ctx, {
          type: "line",
          data: {
            labels: opt_month_name,
            datasets: [
              {
                // label: "Jun 12",
                data: this.databarchartEngagementScore['company'],
                newLabels: this.databarchartEngagementScore['newLabels'],
                backgroundColor: "#32C2D5",
                fill: true,
                borderColor: "#32C2D5",
                borderWidth: 1,
                pointRadius: 0
              },
            ],
          },
          options: {
            interaction: {
              intersect: false,
              mode: 'nearest'
            },
            maintainAspectRatio: false,
            scales: {
              y: {
                display: false,
                max: yMax,
                min: 0,
                ticks: {
                  stepSize: 50,
                  callback: function (value) {
                    return value;
                  },
                },
                grid: {
                  display: false,
                },
              },
              x: {
                ticks: {
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                  font: {
                    color: 'black',
                    size: 12,
                    weight: 'bold',
                    family: 'Lato'
                  },
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                formatter: function (value, context) {
                  return value;
                },
                font: {
                  weight: "bold",
                  size: 10,
                },
              },
              tooltip: {
                mode: "index",
                position: "nearest",
                callbacks: {
                  title: (tooltipItems) => {
                    return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                  },
                  label: function (tooltipItems) {
                    const value = tooltipItems.formattedValue;
                    return ` ${value}`;
                  },
                },
                titleFont: {
                  weight: 'bold',
                },
              },
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            responsive: true,
          },
        });
      }
    },
    renderChartEngagementScoreManager() {
      var chart = this.$refs.chartEngagementScoreManager;
      if (chart) {
        var ctx = chart.getContext("2d");
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

        options.responsive = true;
        options.maintainAspectRatio = false;
        let opt_month_name = this.databarchartEngagementScore['labels']
        let maxScore = this.databarchartEngagementScore['maxScore']
        let yMax = maxScore < 50 ? 50 : (maxScore < 75 ? 75 : 100);
        this.engagement_score_bar_chart = new Chart(ctx, {
          type: "line",
          data: {
            labels: opt_month_name,
            datasets: [
              {
                // label: "Jun 12",
                data: this.databarchartEngagementScore['manager'],
                newLabels: this.databarchartEngagementScore['newLabels'],
                backgroundColor: "#E45006",
                fill: true,
                borderColor: "#E45006",
                borderWidth: 1,
                pointRadius: 0
              },
            ],
          },
          options: {
            interaction: {
              intersect: false,
              mode: 'nearest'
            },
            maintainAspectRatio: false,
            scales: {
              y: {
                display: false,
                max: yMax,
                min: 0,
                ticks: {
                  stepSize: 50,
                  callback: function (value) {
                    return value;
                  },
                },
                grid: {
                  display: false,
                },
              },
              x: {
                ticks: {
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                  font: {
                    color: 'black',
                    size: 12,
                    weight: 'bold',
                    family: 'Lato'
                  },
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                formatter: function (value, context) {
                  return value;
                },
                font: {
                  weight: "bold",
                  size: 10,
                },
              },
              tooltip: {
                mode: "index",
                position: "nearest",
                callbacks: {
                  title: (tooltipItems) => {
                    return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                  },
                  label: function (tooltipItems) {
                    const value = tooltipItems.formattedValue;
                    return ` ${value}`;
                  },
                },
                titleFont: {
                  weight: 'bold',
                },
              },
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            responsive: true,
          },
        });
      }
    },
    renderChartEngagementScoreLeader() {
      var chart = this.$refs.chartEngagementScoreLeader;
      if (chart) {
        var ctx = chart.getContext("2d");
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

        options.responsive = true;
        options.maintainAspectRatio = false;
        let opt_month_name = this.databarchartEngagementScore['labels']
        let maxScore = this.databarchartEngagementScore['maxScore']
        let yMax = maxScore < 50 ? 50 : (maxScore < 75 ? 75 : 100);
        this.engagement_score_bar_chart = new Chart(ctx, {
          type: "line",
          data: {
            labels: opt_month_name,
            datasets: [
              {
                // label: "Jun 12",
                data: this.databarchartEngagementScore['leader'],
                newLabels: this.databarchartEngagementScore['newLabels'],
                backgroundColor: "#E048DA",
                fill: true,
                borderColor: "#E048DA",
                borderWidth: 1,
                pointRadius: 0
              },
            ],
          },
          options: {
            interaction: {
              intersect: false,
              mode: 'nearest'
            },
            maintainAspectRatio: false,
            scales: {
              y: {
                display: false,
                max: yMax,
                min: 0,
                ticks: {
                  stepSize: 50,
                  callback: function (value) {
                    return value;
                  },
                },
                grid: {
                  display: false,
                },
              },
              x: {
                ticks: {
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                  font: {
                    color: 'black',
                    size: 12,
                    weight: 'bold',
                    family: 'Lato'
                  },
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                formatter: function (value, context) {
                  return value;
                },
                font: {
                  weight: "bold",
                  size: 10,
                },
              },
              tooltip: {
                mode: "index",
                position: "nearest",
                callbacks: {
                  title: (tooltipItems) => {
                    return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                  },
                  label: function (tooltipItems) {
                    const value = tooltipItems.formattedValue;
                    return ` ${value}`;
                  },
                },
                titleFont: {
                  weight: 'bold',
                },
              },
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            responsive: true,
          },
        });
      }
    },
    sortBy(type) {
      if (type == "lowest") {
        document.getElementById("sortby").innerHTML = this.$t(
          "insights.Lowest_Success_Score"
        );
      } else if (type == "highest") {
        document.getElementById("sortby").innerHTML = this.$t(
          "insights.Highest_Success_Score"
        );
      }
      this.$store.dispatch("dashboard/sortBy", type);
    },
    getImgUrlDim(pic) {
      var images = require.context(
        "../../assets/images/dimension/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    showList() {
      this.$store.dispatch("dashboard/getDataTalkingPointsMonthly", this.user);
      this.dialogVisible = true;
    },
    setMonthly(MonthYear) {
      let split = MonthYear.split("-");
      let labelOpt = format(new Date(split[0], split[1], ""), "MMMM YYYY");
      return labelOpt;
    },
    getFontStyle(text) {
      if (text.match(/[ก-๙]/)) {
        return "Kanit";
      } else {
        return "Lato";
      }
    },
    DimensionClicked(row) {
      this.$store.dispatch("dashboard/resetState");
      let data = {
        dimpic: row.dimpic,
        name: row.name,
        quest_id: row.quest_id,
      };
      this.dimensionData = data;
      this.$store.dispatch("dashboard/getDataChart", {
        user: this.user,
        quest_id: row.quest_id,
      });
      this.$store.dispatch("dashboard/getDataTalkingPoints30D", {
        user: this.user,
        category_id: row.category_id,
      });
      this.dialogDimensionVisible = true;
    },
    truncateText(text) {
      let length = this.maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    truncateTextKeyGroup(text) {
      let length = 18;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    activeLineHeight(value) {
      let percentage = (value / this.maximumUsers) * 100;
      return (40 / 100) * percentage;
    },
    arrayToPercentage(value) {
      const arr = [];
      let color = "bar-red";
      if (value > 70) {
        color = "bar-green";
      } else if (value > 40) {
        color = "bar-yellow";
      }
      for (let i = 0; i < 10; i++) {
        let status = (value - i * 10) * 1;
        let style = "";
        if (status > 10) {
          style = "";
        } else if (value - i * 10 > 0) {
          style = `opa-0${status * 1}`;
        } else {
          color = "";
        }
        arr.push(`${style} ${color}`);
      }
      return arr;
    },
    managerChart() {
      this.managerChartData = [];
      if (this.activeOverview.all > 28) {
        let dot = this.activeOverview.all / 28;
        let active = (this.activeOverview.active / dot).toFixed();
        let passive = (this.activeOverview.passive / dot).toFixed();
        for (var i = 0; i < 28; i++) {
          if (i < active) {
            this.managerChartData.push("green");
          } else if (i < parseInt(active) + parseInt(passive)) {
            this.managerChartData.push("yellow");
          } else {
            this.managerChartData.push("red");
          }
        }
        this.managerLoading = false;
      } else {
        for (var i = 0; i < 28; i++) {
          if (i < this.activeOverview.active) {
            this.managerChartData.push("green");
          } else if (
            i <
            parseInt(this.activeOverview.active) +
            parseInt(this.activeOverview.passive)
          ) {
            this.managerChartData.push("yellow");
          } else if (
            i <
            parseInt(this.activeOverview.active) +
            parseInt(this.activeOverview.passive) +
            parseInt(this.activeOverview.inactive)
          ) {
            this.managerChartData.push("red");
          } else {
            this.managerChartData.push("gray");
          }
        }
        this.managerLoading = false;
      }
    },
    benchmarkBar(value) {
      if (this.checkedInxed()) {
        if (value < 0) {
          return "0";
        } else if (value > 99) {
          return "120";
        }
        return (value * 1.2).toFixed();
      } else {
        if (value < -99) {
          return "0";
        } else if (value > 99) {
          return "120";
        }
        return ((value + 100) * 0.6).toFixed();
      }
    },
    routerLink(path, tab, query) {
      if (path == "insightsWithTab" && tab) {
        // if (tab == "managers") {
        //   this.$store.commit("insightsManagers/setTabManager", true);
        // }
        this.$emit("changedTab", { path, tab });
      } else if (tab) {
        if (query) {
          this.$router.push({
            name: path,
            params: { tab: tab },
            query: { questionID: query },
          });
          this.$store.commit("dashboard/setOpenModalDashboard", true);
        } else {
          this.$router.push({ name: path, params: { tab: tab } });
        }
      } else {
        this.$message.error("Oops, Something wrong with this link.");
      }
    },
    setEngagementImpactLoading() {
      if (
        this.impactRatingLoading == false &&
        this.managerLoading == false &&
        this.enpsLoading == false
      ) {
        this.engagementImpactLoadingStatus = false;
      } else {
        this.engagementImpactLoadingStatus = true;
      }
    },
    setWeeklyLoadingStatus() {
      if (this.feedbackLoading == false && this.happinessLoading == false) {
        this.weeklyLoadingStatus = false;
      } else {
        this.weeklyLoadingStatus = true;
      }
    },
    benchmarkScore() {
      if (!this.checkedInxed()) {
        return 30;
      }
      return 80;
    },
    benchmarkScoreRed() {
      if (!this.checkedInxed()) {
        return 0;
      }
      return 50;
    },
    checkedInxed() {
      let index = this.benchmarkBreak != "eNPS" && this.benchmarkBreak != "NPS";

      if (index) {
        return true;
      }
      return false;
    },
    imagesBenchmark(value) {
      if (this.checkedInxed) {
        let benchmark = "Resilience";
        let type = "Critical";
        switch (this.benchmarkBreak) {
          case "WHO-5 Wellbeing Index":
            benchmark = "Wellness";
            break;
          case "Culture Index":
            benchmark = "Culture";
            break;
          case "Employee Resilience Index":
            benchmark = "Resilience";
        }
        if (value == "Excellent") {
          type = "Excellence";
        } else if (value == "Fair") {
          type = "Fair";
        }
        return `benchmark_${benchmark} - ${type}_16x16`;
      } else {
        if (value == "Excellent") {
          type = "Excellent";
          return "Promoters_16";
        } else if (value == "Fair") {
          return "Passives_16";
        }
        return "Distractors_16";
      }
    },
    detectColorTotal(type) {
      let value = 0;
      if(this.databarchartEngagementScore[type] && this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1]){
        value = this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1];
      }
      if(value >= 70){
        return "green";
      }else if(value < 70 && value >= 40){
        return "yellow";
      }else{
        if(this.databarchartEngagementScore[type] && this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1]){
          return "red";
        }else{
          return "";
        }
      }
    },
    detectTextTotal(type) {
      let value = 0;
      if(this.databarchartEngagementScore[type] && this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1]){
        value = this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1];
      }
      if(value >= 70){
        return "GOOD";
      }else if(value < 70 && value >= 40){
        return "OKAY";
      }else{
        if(this.databarchartEngagementScore[type] && this.databarchartEngagementScore[type][this.databarchartEngagementScore[type].length - 1]){
          return "POOR";
        }else{
          return "-";
        }
      }
    },
    getScoreCount(score) {
      if (!this.enps || !this.enps.allScores) return 0;
      
      const scoreItem = this.enps.allScores.find(item => {
        return Number(item.score) === Number(score);
      });
      
      return scoreItem ? scoreItem.count : 0;
    },
    
    getScoreWidth(score) {
      if (!this.enps || !this.enps.allScores) return '0%';
      
      const count = this.getScoreCount(score);
      if (count === 0) return '0%';
      
      const counts = this.enps.allScores.map(item => item.count);
      const maxCount = counts.length > 0 ? Math.max(...counts) : 1;
      
      return `${(count * 100 / maxCount)}%`;
    },
    getScoreRange() {
      if (this.enps.type === 'WHO-5 Wellbeing Index') {
        // Return array [0, 10, 20, ..., 100] for WHO-5
        return Array.from({ length: 11 }, (_, i) => i * 10);
      }
      // Return array [0,1,2,...,10] for NPS/eNPS
      return Array.from({ length: 11 }, (_, i) => i);
    },

    formatScoreLabel(score) {
      if (this.enps.type === 'WHO-5 Wellbeing Index') {
        return score === 100 ? '100' : `${score}`;
      }
      return score.toString();
    },

    getScoreColor(score) {
      if (this.enps.type === 'WHO-5 Wellbeing Index') {
        // WHO-5 color scheme: red < 50, yellow 50-69, green >= 70
        return score >= 70 ? '#35d077' : score >= 50 ? '#fbc02d' : '#f44336';
      }
      // NPS/eNPS color scheme
      return score >= 9 ? '#35d077' : score <= 6 ? '#f44336' : '#fbc02d';
    },

    getTotalResponses() {
      if (!this.enps || !this.enps.allScores) return 0;
      
      // Use allScores array to calculate total responses
      if (this.enps.allScores && this.enps.allScores.length > 0) {
        return this.enps.allScores.reduce((sum, item) => sum + (item.count || 0), 0);
      }
      
      // Fallback to the old method if allScores is not available
      if (this.enps.type === 'WHO-5 Wellbeing Index') {
        return this.enps.excellent + this.enps.fair + this.enps.critical || 0;
      }
      return this.enps.promotors + this.enps.passives + this.enps.detractors || 0;
    },
  },
};
</script>
<style scoped lang="scss">
#insightsDashboard>>>img {
  border-radius: 50%;
}

.flex.card {
  justify-content: center;
}

.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.divTable {
  flex: 1;
  margin-left: -9px;
}

.txtDetailTable {
  color: #9d9d9d;
  font-size: 14px;
  word-break: normal;
}

// .card-box {
//   margin-top: 20px;
//   margin-right: 20px;
//   width: 180px;
//   height: 100px;
//   border-radius: 5px;
//   background-color: #f4f4f4;
//   text-align: center;
//   box-sizing: border-box;
// }
.KeyGroupBox {
  margin-top: 6px;
  margin-right: 6px;
  width: 168px;
  height: 48px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  // box-shadow: 0px 2px 4px #00000029;
  box-sizing: border-box;
  overflow: hidden;
  cursor: default;
}

#insightsDashboard .KeyGroupBox img {
  border-radius: 0;
}

// .txtHeadBox {
//   padding: 21px 5px 2px 5px;
//   font-size: 36px;
//   color: #363636;
//   display: inline-block;
// }
.txtHeaderKey {
  font-size: 12px;
  color: #535353;
  font-weight: 700;
  white-space: nowrap;
}

.txtDetailKey {
  font-size: 10px;
  color: #000000;
  opacity: 0.5;
}

.txtPercent {
  margin-left: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #999999;
}

.txtPercent.green {
  color: #27bc6c;
}

.txtPercent.red {
  color: #f44336;
}

.txtPercent.grey {
  color: #747474;
}

.divCurcleStatus {
  margin-left: 5px;
  margin-right: 5px;
  width: 50px;
  height: 48px;
  text-align: center;
  border-radius: 50%;
}

.divCurcleStatus.green {
  background-color: #66bb6a;
}

.divCurcleStatus.yellow {
  background-color: #fbc02d;
}

.divCurcleStatus.red {
  background-color: #f44336;
}

.divCurclePic {
  margin-left: 5px;
  margin-right: 5px;
  width: 60px;
  height: 60px;
  text-align: center;
  border-radius: 50%;
  background-color: #f0f0f0;
}

.txtStatus {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding: 0px;
  line-height: 50px;
}

.txtButton {
  padding: 0;
  margin-left: 16px;
  font-size: 14px;
}

.el-button--text {
  color: #6c30cc;
}

.el-button--text:hover {
  color: #5423a2;
}

.el-button--text:active {
  color: #6c30cc;
}

.talkingPointsBox {
  height: 40px;
}

.talking-points {
  border-width: 0;
  border-radius: 16px;
  font-weight: 700;
  // box-shadow: 0px 2px 4px #00000029;
  transition: 0.2s;
  margin: 8px 8px 0 0;

  &:hover {
    margin-top: 5px;
    // box-shadow: 0px 5px 6px #00000019;
    margin-bottom: 3px;
  }
}

.GreenBoxStyle {
  color: #249d2a;
  background-color: #edffee;
}

.RedBoxStyle {
  color: #f44336;
  background-color: #ffedeb;
}

.GreyBoxStyle {
  color: #484848;
  // border-color: #b2b2b2;
  background-color: #f0f0f0;
}

.buttonClose {
  padding-top: 10px;
  height: 36px;
  font-size: 16px;
  font-weight: 700;
}

.headerModalStyle {
  margin-left: 20px;
  margin-right: 52px;
  margin-top: 30px;
}

.txtMonthlyStyle {
  color: #747474;
  font-size: 16px;
  font-weight: 700;
}

.scroll-style {
  max-height: 58vh;
  padding-bottom: 1px;
}

.scrollingStyle2 {
  max-height: 55vh;
}

.txtDimensionDesc {
  color: #626262;
  font-size: 14px;
}

.barchart-style {
  background-color: rgba(0, 0, 0, 0.03);
  // box-shadow: 0px 2px 4px #00000029;
  border-radius: 24px;
  margin-top: 10px;
  width: calc(100% - 42px);
  height: 186px;
  padding: 10px 24px 12px 18px;
}

.chart-legend {
  display: flex;
  padding: 4px 12px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  align-items: center;
  margin: 6px 0 0 12px;
}

.chart-legend .symbol {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 8px;
}

.symbol.blue {
  background-color: #00ACC1;
}

.symbol.orange {
  background-color: #E45006;
}

.symbol.pink {
  background-color: #E048DA;
}

.chart-legend .tag {
  margin-left: 8px;
  padding: 1px 8px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
}

.chart-legend .tag.yellow {
  background-color: rgba(251, 192, 45, .20);
  color: #C3931E;
}

.chart-legend .tag.red {
  background-color: rgba(244, 67, 54, .20);
  color: #C73A2F;
}

.chart-legend .tag.green {
  background-color: rgba(102, 187, 106, .20);
  color: #559B58;
}

.barchart-engagement-style {
  width: calc(100% - 12px);
  height: 120px;
}

.chartStyle {
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 24px;
}

.tooltipStyle {
  width: 375px;
  padding: 8px;
}

/* จัดการรายการภายใน Tooltip */
.tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* สไตล์ตัวเลขวงกลม (OI) */
.oi-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: rgba(108, 48, 204, 0.2); /* สีพื้นหลัง */
  // opacity: 0.2;
  color: #6C30CC; /* สีตัวอักษร */
  font-weight: bold;
  margin-right: 12px;
}

/* ข้อความ */
.tooltip-item {
  display: flex;
  align-items: flex-start;
  padding-top : 11px;
}

.tooltip-item p {
  margin: 0;
  font-size: 12px;
}

.tooltipHelpStyle {
  width: 218px;
}

.tooltipKeyGroupStyle {
  max-width: 250px;
}

.grid-2-second {
  display: grid;
  grid-template-columns: 40% 60%;
}

.icon-beta {
  padding: 5px 12px 3px;
  border-radius: 12px;
  background-color: #1ec182;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  margin-left: 12px;
}

.tone-body {
  margin-top: 14px;

  .arrow {
    height: 14px;
    width: 20px;

    >img {
      height: 12px;
      width: 12px;
      margin-top: 8px;
    }
  }

  .number {
    width: 28px;
    margin-top: 3px;
  }

  .emoji {
    width: 120px;
  }

  .percentage-bar {
    width: 80px;
    margin-top: 7px;
  }

  .percentage-number {
    width: 35px;
    text-align: end;
    margin-left: 4px;
    margin-top: 2px;
  }

  .percentage-change-number {
    margin-left: 10px;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    padding: 4px 4px 2px;
  }

  .percentage-change-number.up {
    background-color: #12c29a;
    color: #fff;
  }

  .percentage-change-number.down {
    background-color: #e2e2e2;
    color: #5c5c5c;
  }
}

.grid-2-tenure {
  display: grid;
  grid-template-columns: 652px auto;
}

.grid-3-engagement {
  display: grid;
  grid-template-columns: 33% 33% 33%;
}

.past-12-hours {
  .card {
    padding: 14px 16px 20px;
    margin-top: 8px;
    height: calc(200px - 32px + 6px);
    color: #fff;
    border-radius: 24px;
    background-color: #6c30cc;
    // box-shadow: 0px 2px 4px #00000029;
  }

  .active-bar {
    background-color: #35d077;
    width: 6px;
    margin-left: 2px;
    transition: 0.3s;

    &:hover {
      background-color: #16b65b;
    }
  }

  .line {
    height: 1px;
    background-color: #fff;
    opacity: 0.2;
    margin-top: 4px;
    margin-bottom: 9px;
  }
}

.top-contariner {

  // display: grid;
  // grid-template-columns: auto auto auto;
  .x-line {
    width: 100%;
    height: 1px;
    background-color: rgba($color: #000000, $alpha: 0.1);
  }

  .card-contariner {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow:
      0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
      0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
      0px 1.5px 4px rgba(0, 0, 0, 0.015),
      0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
      0px 5px 13.4px rgba(0, 0, 0, 0.022),
      0px 12px 32px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    padding: 24px 16px 12px;
    margin-top: 8px;
    height: 234px;
  }

  .label-change {
    font-size: 11px;
    font-weight: 700;
    margin-top: 4px;
    margin-left: 3px;
    white-space: nowrap;
  }

  // .engagement,
  // .weekly-status,
  // .activity {
  // }
  .engagement {
    width: calc(100% - (460px + 32px));

    .dot-green {
      background-color: #35d077;
    }

    .dot-yellow {
      background-color: #fbc02d;
    }

    .dot-red {
      background-color: #f44336;
    }

    .dot-gray {
      background-color: #e0e0e0;
    }

    .engagement-left {
      width: calc(50% - 12px);
      padding-right: 12px;
      border-right: 1px solid rgba($color: #000000, $alpha: 0.1);

      .grid-dot-10 {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto auto auto auto;
        user-select: none;
        padding-right: 12px;
      }

      .dots-50 {
        width: 12px;
        height: 12px;
        margin: 0 auto 3px;
        border-radius: 12px;
      }
    }

    .engagement-right {
      padding-left: 24px;

      .grid-dot-7 {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto;
        user-select: none;
      }

      .dots-28 {
        width: 16px;
        height: 16px;
        margin: 0 auto 3px;
        border-radius: 16px;
      }
    }

    .benchmark {
      width: 46px;
      text-align: center;
      padding: 10px 0 8px;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      border-radius: 4px;
      margin-right: 16px;
      background-color: #e0e0e0;
      cursor: help;
    }

    .benchmark.green {
      background-color: #35d077;
    }

    .benchmark.red {
      background-color: #f44336;
    }

    .benchmark.yellow {
      background-color: #fbc02d;
    }

    .point-bar {
      width: 120px;
      border-radius: 6px;
      height: 6px;
      background-color: rgba($color: #000000, $alpha: 0.2);

      .value {
        position: relative;
        border-radius: 6px;
        height: 6px;
        background: #35d077;
      }

      .value.benchmark {
        position: relative;
        height: 6px;
        top: -6px;
        background: transparent;

        &::before {
          content: "";
          position: absolute;
          right: -1px;
          top: -3px;
          border-right: 2px solid #6c30cc;
          height: 12px;
        }
      }
    }
  }

  .weekly-status {
    margin-left: 16px;
    width: 230px;
  }

  .activity {
    margin-left: 16px;
    width: 230px;

    .bar-contariner {
      .bar {
        border-radius: 6px;
        width: 6px;
        height: 24px;
        margin-right: 2px;
        background-color: rgba($color: #000000, $alpha: 0.1);
      }

      .bar-green {
        background-color: #35d077;
      }

      .bar-yellow {
        background-color: #fbc02d;
      }

      .bar-red {
        background-color: #f44336;
      }
    }
  }
}

.score-distribution-tooltip {
  min-width: 280px !important;
  padding: 16px !important;
  background: #2d2d2d !important;
  border-radius: 4px !important;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2) !important;

  .tooltip-title {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #000000;
    text-align: left;
  }

  .score-bars {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .score-bar-item {
      display: grid;
      grid-template-columns: 30px 30px 1fr;
      align-items: center;
      height: 20px;

      .score-info {
        display: contents;

        .score-label {
          font-size: 12px;
          font-weight: 500;
          color: rgba(255,255,255,0.7);
          padding-right: 0px;
        }

        .score-count {
          font-size: 11px;
          color: rgba(255,255,255,0.5);
        }
      }

      .score-bar-wrapper {
        position: relative;
        background-color: rgba(255,255,255,0.1);
        border-radius: 2px;
        height: 3px;
        margin-top: 2px;

        .score-bar {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          transition: width 0.3s ease;
          border-radius: 2px;
          width: 4px;
        }
      }
    }
  }
}

.horizontal-histogram {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.score-labels, .histogram-bars, .score-counts {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.score-labels {
  margin-bottom: 4px;
}

.score-counts {
  margin-top: 4px;
}

.score-label-item, .score-count-item {
  flex: 1;
  text-align: center;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
}

.score-count-item {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
}

.histogram-bars {
  height: 120px;
  align-items: flex-end;
  margin: 10px 0;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  
  /* Add horizontal grid lines for better readability */
  &::after {
    box-shadow: 0 30px 0 rgba(0, 0, 0, 0.03),
                0 60px 0 rgba(0, 0, 0, 0.03),
                0 90px 0 rgba(0, 0, 0, 0.03);
  }
}

.histogram-bar {
  flex: 1;
  margin: 0 6px;
  min-height: 1px;
  transition: height 0.3s ease, transform 0.2s ease;
  width: 8px;
  border-radius: 4px 4px 0 0;
  position: relative;
  
  &:hover {
    transform: scaleY(1.05);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
  }
  
  &::after {
    content: attr(data-value);
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  
  &:hover::after {
    opacity: 1;
  }
}

</style>
<style>
.tooltip-emoji-detail {
  max-width: 300px;
}

#insightsDashboard>div>div:nth-child(1)>div>div>input {
  height: 52px !important;
  font-size: 18px;
  font-weight: 400;
  color: #4a4a4a;
}

#insightsDashboard>div>div.>div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsDashboard>div>div.2>div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsDashboard .el-dialog {
  width: 1024px;
}

#insightsDashboard .el-dialog__body {
  padding: 10px 20px;
}

#insightsDashboard .el-dialog__footer {
  padding-top: 0px;
}
</style>
